import { Flex, Grid, Text } from '@radix-ui/themes';
import { DashboardStatistic } from '@/lib/enum/dashboardStatistic';
import { AuctionStatistic } from '@/app/api/statistics/auction/[auctionId]/route';
import { Skeleton } from '../ui/skeleton';
import StatisticPanel from '../StatisticPanel';
import { statisticsIconMap } from './statisticsIconMap';

interface Props {
  currentAuctionExists: boolean;
  currentAuctionStatistics: AuctionStatistic[];
  currentAuctionStatisticsLoading: boolean;
}

const CurrentAuctionStatisticsPanel = ({
  currentAuctionExists,
  currentAuctionStatistics,
  currentAuctionStatisticsLoading
}: Props) => {
  if (!currentAuctionExists) {
    return (
      <Flex direction="column" justify="center" align="center" className="flex-grow w-full h-full">
        <Text className="text-slate-700">
          Please create an auction to view statistics.
        </Text>
      </Flex>
    );
  }

  return (
    <Grid
      columns={{ initial: "1", sm: "2" }}
      gapY="4"
      gapX="6"
      className="w-full h-min py-8"
    >
      {currentAuctionStatisticsLoading ? (
        [1, 2, 3, 4].map((_, idx) => (
          <Skeleton key={idx} className="h-28 w-full mb-1" />
        ))
      ) : (
        currentAuctionStatistics?.map((statistic, idx) => (
          <StatisticPanel
            key={idx}
            title={statistic.title}
            value={statistic.value}
            subtitle={statistic.subtitle}
            href={statistic.href}
            Icon={statisticsIconMap[statistic.title as DashboardStatistic]}
          />
        ))
      )}
    </Grid>
  );
};

export default CurrentAuctionStatisticsPanel; 